export default "__VITE_ASSET__cs_r7lqq__"